import { render, staticRenderFns } from "./TerminationCareAssistance.vue?vue&type=template&id=cef8e092&"
import script from "./TerminationCareAssistance.vue?vue&type=script&lang=js&"
export * from "./TerminationCareAssistance.vue?vue&type=script&lang=js&"
import style0 from "./TerminationCareAssistance.vue?vue&type=style&index=0&id=cef8e092&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports